export default "__VITE_ASSET__899b02f5__"